const NAMESPACE = 'INTERLINK';

const SET_INTERLINK_DATA = `${NAMESPACE}/SET_C2C_INTERLINK_DATA`;

export {
    SET_INTERLINK_DATA,
};

export default NAMESPACE;
